// extracted by mini-css-extract-plugin
export default {"searchIcon":"fNFKX","searchIconClickable":"aobNk fNFKX","searchInput":"Tb0e6"};